import { defineStore } from 'pinia'

/** Converted from store/defaultLayoutVars.js. Drives the app bar and nav drawer. */
export const useDefaultLayoutVarsStore = defineStore('defaultLayoutVars', {
  state: () => ({
    menuBarAvatar: null as unknown,
    menuBarPrefix: null as unknown,
    menuBarTitle: null as string | null,
    drawer: true,
  }),
  getters: {
    getMenuBarAvatar: (state) => state.menuBarAvatar,
    getMenuBarPrefix: (state) => state.menuBarPrefix,
    getMenuBarTitle: (state) => state.menuBarTitle,
    getDrawer: (state) => state.drawer,
  },
  actions: {
    setMenuBarAvatar(object: unknown): void {
      this.menuBarAvatar = object
    },
    setMenuBarPrefix(object: unknown): void {
      this.menuBarPrefix = object
    },
    setMenuBarTitle(title: string | null): void {
      this.menuBarTitle = title
    },
    setDrawer(stateToSet: boolean): void {
      this.drawer = stateToSet
    },
  },
})
